import {
  Length,
  maxLength,
  required
} from "@libs/validation/fieldValidators.ts";
import { Validator } from "@libs/validation/Validator.ts";

import { DashFormValues } from "../DASHForm.types.ts";

const checkDisabilityQuestions = (
  _value: string,
  parent: DashFormValues["items"]
) => {
  const questionsAnswered: string[] = [];
  for (let i = 1; i < 12; i++) {
    const question = parent ? parent[`q${i}`] : undefined;
    if (question) {
      questionsAnswered.push(question);
    }
  }

  return questionsAnswered.length < 10;
};

const checkWorkQuestions = (
  _value: string,
  parent: DashFormValues["items"]
) => {
  const questionsAnswered: string[] = [];
  for (let i = 13; i < 17; i++) {
    const question = parent ? parent[`q${i}`] : undefined;
    if (question) {
      questionsAnswered.push(question);
    }
  }

  const textQuestion = parent ? parent["q12"] : undefined;
  if (textQuestion && questionsAnswered.length === 0) {
    return true;
  }

  return !(questionsAnswered.length === 0 || questionsAnswered.length === 4);
};

const checkSportQuestions = (
  _value: string,
  parent: DashFormValues["items"]
) => {
  const questionsAnswered: string[] = [];
  for (let i = 18; i < 22; i++) {
    const question = parent ? parent[`q${i}`] : undefined;
    if (question) {
      questionsAnswered.push(question);
    }
  }

  const textQuestion = parent ? parent["q17"] : undefined;
  if (textQuestion && questionsAnswered.length === 0) {
    return true;
  }

  return !(questionsAnswered.length === 0 || questionsAnswered.length === 4);
};

export class DASHFormValidator extends Validator<DashFormValues["items"]> {
  constructor() {
    super();
    this.forField("q12", maxLength(Length.short));
    this.forField("q17", maxLength(Length.short));

    const disabilityQuestions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

    disabilityQuestions.forEach(i => {
      this.forField(`q${i}`, required(), {
        when: checkDisabilityQuestions
      });
    });

    const workQuestions = [12, 13, 14, 15, 16];

    workQuestions.forEach(i => {
      this.forField(`q${i}`, required(), {
        when: checkWorkQuestions
      });
    });

    const sportQuestions = [17, 18, 19, 20, 21];

    sportQuestions.forEach(i => {
      this.forField(`q${i}`, required(), {
        when: checkSportQuestions
      });
    });
  }
}
